import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DivisionWiseCropDetailsReport } from './Pages'

export const DivisionWiseCropDetailsReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={DivisionWiseCropDetailsReport} />
    </Fragment>
)